import './App.css';
import CustomerDisplayCart from './components/CustomerDisplayCart';

function App() {
  return (
    <div className="w-screen flex flex-col bg-gray-50 justify-center h-dvh">
      <CustomerDisplayCart refreshInterval={500} />
    </div>
  );
}

export default App;
